<div class="popupbg">
  <div class="reg-popcont">
      <div class="regredbar">
          <img style="margin-left: 10%;" src="../assets/images/regala1gbbanv3.png">
          <div class="regpopmsg vcenter f-white roboto-r right">
              <div class="tabcell">
                  <span class="f-bigtitle roboto-b">
                      USTED
                  </span><br/>
                  <span class="f-big">
                      HA RECIBIDO UN REGALO DE DATA
                  </span>
              </div>
          </div>
      </div>

      <div class="basicrow allpads roboto-r f-black f-med">
          <div class="basicrow m-top-iv m-bott-i text-center">
              <div class="basicrow roboto-m f-big">
                  {{this.nameSend}}
              </div>

              <div class="basicrow f-bmed">
                  Le ha enviado un regalo de 1GB de Data de regalo.
              </div>

              <div class="basicrow m-top-ii">
                  <div class="logline full"></div>
              </div>

              <div class="basicrow m-top-ii">
                  {{this.giftMessage}}
              </div>

              <div class="basicrow m-top-ii">
                  <div class="btns red def-i centr vcenter" (click)="this.acceptGift()">
                      <span class="tabcell">
                         OK&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                      </span>
                    </div>
              </div>
          </div>
      </div>
  </div>
</div>
